export default {
  errors: {
    "grid-connection-not-present":
      "There is no grid connection application for this project on the platform. This means we cant aid in the resale agreement",
    "grid-connection-not-complete":
      "This project has not been connected to the grid yet",
  },
  card: {
    type: "Type de contrat",
    status: "État",
    restricted: "Non disponible pour le projet",
  },
  types: {
    FEED_IN_TARIFF: "Contrats d’achat",
    VIRTUAL_BATTERY: "Batterie virtuelle",
  },
  unavailable: {
    title: "Service indisponible",
    description:
      "Suivez notre lettre d'information via email ainsi que nos réseaux sociaux pour être informé de la mise en disponibilité.",
  },
  "edf-oa": {
    hero: {
      title: "EDF OA",
      heading: "Aider votre client à obtenir son contrat d’achat",
      description:
        "Assurez-vous que votre client rentabilise son investissement solaire. Gérez ici le contrat de valorisation du surplus de production d'électricité de votre client.",
    },
    statuses: {
      NOT_ADDED: "Ajouter contrat",
      COMPLETE: "Signature du contrat",
      PREPARING: "Préparation",
      NOTIFIED: "Obtention du numéro de contrat",
      ACCOUNT_SETUP: "Ouverture du compte",
      ELECTRICAL_SAFETY_INSPECTION_QUOTE_REQUESTED:
        "Devis demandé de l'organisme inspection",
      ELECTRICAL_SAFETY_INSPECTION_QUOTE_RECEIVED:
        "Devis obtenu de l'organisme inspection",
      ELECTRICAL_SAFETY_INSPECTION_QUOTE_SIGNED:
        "Devis signé de l'organisme inspection",
      ELECTRICAL_SAFETY_INSPECTION_SCHEDULED:
        "Contrôle de conformité ENR prévu",
      ELECTRICAL_SAFETY_INSPECTION_COMPLETE:
        "Rapport ENR d’organisme d’inspection complet",
        AUCTION_APPLICATION_SUBMITTED:
        'Candidature déposée à l’Appel d’Offres Simplifié (AOS)',
        AUCTION_APPLICATION_ACCEPTED: 'Candidature acceptée à l’Appel d’Offres Simplifié (AOS)',
        AUCTION_APPLICATION_REJECTED: 'Candidature rejetée à l’Appel d’Offres Simplifié (AOS)',
      SENT: "Demande du contrat prêt pour signature",
      CONFIRMED: "Attente des services d'EDF OA",
    },
    types: {
      BELOW_100_KWC: "En dessous de 100 kWc",
      ABOVE_100_KWC: "Au-dessus de 100 kWc",
      AUCTION: "Appel d'offres",
    },
    billing: {
      title: "Facturation de la vente de production d’électricité",
      "paragraph-1":
        "Pour obtenir le paiement du montant de vente de surplus de la part d’EDF OA, il faut réaliser une facture depuis l’espace en ligne. D'une manière réglementaire, EDF OA ne peut pas procéder au paiement sans la facture.",
      "paragraph-2":
        "Le montant financier de la vente de production est calculé automatiquement à partir des index (en kWh) fournis lors de la facturation en ligne.",
      "index-reading": {
        title: "Relever les index depuis compteur",
        description:
          "Le montant financier de la vente de production est calculé automatiquement à partir des index (en kWh) fournis lors de la facturation en ligne.",
        linky: {
          heading: "Relever avec compteur Linky",
          "paragraph-1":
            "Il faut relever <strong>deux index</strong> de production et de non-consommation",
          "paragraph-2":
            "Pour relever mes index, j’appuie sur la touche (+) en dessous de l’écran d’affichage. ",
          "list-item-1":
            "Je relève l’index que je vois apparaître « index d’injection » ",
          "list-item-2":
            "Puis je relève l’index de « non-consommation » sous le message « index non conso »",
        },
        mechanical: {
          heading: "Relever avec ancien compteur",
          "paragraph-1":
            "Il faut relever deux index de production et de non-consommation depuis mes compteurs. ",
          "paragraph-2":
            "Si mon compteur est en veille, j’appuie une fois sur la touche 'sélection' afin de voir mon index.",
          "list-item-1":
            "Je relève mon index de production (nombre en kWh) depuis mon compteur Production (injection).",
          "list-item-2":
            "Puis je relève mon index de « non-consommation » (nombre en kWh) depuis mon compteur de « non-consommation », ou consommation des auxiliaires.",
        },
        error:
          "Je ne dois en aucun cas relever les index affichés sur mon onduleur. Cette donnée n’est pas recevable pour EDF Obligation d’Achat.",
      },
      "sending-an-invoice": {
        title: "Envoyer facture à EDF OA",
        description:
          "Vous pouvez facturer uniquement si votre contrat d’achat est signé des 2 parties (producteur et EDF OA. Si votre facturation est annuelle, vous facturez à chaque date anniversaire de la mise en service de votre installation. Si votre facturation est semestrielle, vous devez établir deux factures par an : six mois après la mise en service, puis à la date anniversaire.",
        link: "Vidéo comment faire étape par étape ->",
      },
    },
    support: {
      "customer-support-edf-oa": {
        title: "Service Client EDF OA",
        "text-1": "Adresse email : <a href='mailto:{email}'>{email}</a>",
        "text-2": "Téléphone : 09 69 37 57 07",
        "text-3":
          "Pour des raisons de confidentialité, EDF OA ne répond qu'aux personnes dont le nom figure sur le contrat ou mandat.",
      },
      "customer-support-enedis": {
        title: "Problème technique avec votre  compteur ?",
        "text-1":
          "En cas d’incohérence dans vos données de comptage ou en cas de problème sur votre compteur, Il faut contacter le gestionnaire du réseau électrique ENEDIS ou Régie locale d’électricité.  En effet, ce dernier pourrait, si nécessaire, faire une estimation des index.",
        "text-2": "Numéro de téléphone d’Enedis : 09 69 32 18 00",
      },

      cards: {
        "card-1": {
          title: "Vous vendez votre bien équipé avec vente de production ?",
          description:
            "Le cédant ne doit pas résilier son contrat d'achat mais bien signer un avenant de cession de contrat d'achat avec le cessionnaire pour qu'il puisse en bénéficier.",
        },
        "card-2": {
          title: "Vous souhaitez ajouter des panneaux à votre bien ?",
          description:
            "Il convient alors de déposer une nouvelle demande de raccordement auprès d'Enedis en tant qu’augmentation de puissance.",
        },
        "card-3": {
          title: "Votre installation a subi des dommages ?",
          description:
            "Des remplacements de panneaux sont autorisés sous certaines conditions.",
        },
        "card-4": {
          title: "Enedis est intervenu sur votre compteur ?",
          description:
            "Mon compteur a dû être changé, remis à zéro ou j'ai noté une perte de production ?",
        },
        "card-5": {
          title: "Vous souhaitez résilier votre contrat d’achat ?",
          description:
            "Vous devez adresser votre demande par lettre recommandée avec Accusé de Réception à l'Agence Obligation d'Achat.",
        },
        "card-6": {
          title: "Vous vous mariez, pacsez ou vous divorcez ?",
          description:
            "Lorsque mon statut matrimonial change, je peux demander l'ajout ou la suppression de mon conjoint sur le contrat d'achat.",
        },
        "card-7": {
          title: "Le titulaire du contrat d’achat est décédé ?",
          description:
            "Pour transférer le contrat, plusieurs situations peuvent être rencontrées. Il faut fournir le formulaire héritier.",
        },
        "card-8": {
          title: "Votre contrat arrive à échéance ?",
          description:
            "Votre contrat arrive à échéance prochainement et vous souhaitez savoir  quelles sont les démarches à suivre et les possibilités d’avenir pour  votre installation.",
        },

        "find-out-more": "En savoir plus",
      },
    },

    "account-information": {
      heading: "Informations de compte",
      "contract-reference-id": {
        label: "Numéro de contrat EDF OA",
        description:
          "Ce numéro (BTA, BO ou BOA) est obligatoire pour démarrer la démarche.",
      },
      address: "Adresse de l’installation photovoltaïque",
      "contract-owner-name": "Titulaire du contrat",
    },

    "certificate-of-honour": {
      requirements: {
        heading: "Valeurs utilisées pour la complétion du document",
        "contract-reference-id": "Numéro de contrat EDF OA",
        address: "Adresse de l’installation",
        "installation-date": "Déjà posé",
        title: "Titre du signataire",
        "installer-representative-name": "Nom complet de l’installateur",
        "installer-company-name": "Raison sociale de l’installateur",
        "installer-company-address": "Siège social de l’installateur",
        "installer-stamp": "Tampon de l’installateur",
        "panel-brand-name": "Marque des panneaux",
        "panel-model-name": "Référence des panneaux",
        "panel-manufacturer-name": "Fabricant des panneaux",
        "inverter-brand-name": "Marque onduleur (connectique)",
        "inverter-model-name": "Référence onduleur (connectique)",
        "inverter-manufacturer-name": "Fabricant  onduleur (connectique)",
        "disconnect-brand-name": "Marque coffret (boîtier)",
        "disconnect-model-name": "Référence coffret (boîtier)",
        "disconnect-manufacturer-name": "Fabricant  coffret (boîtier)",
        "installer-signature-location": "Emplacement de l’installateur",
        "client-full-name": "Nom du producteur",
        "client-signature-location": "Emplacement du producteur",
      },
    },
  },
  offers: {
    types: {
      EDF_OA_S21_Q3_2026: "S21 T2 2026",
      EDF_OA_S21_Q2_2026: "S21 T1 2026",
      EDF_OA_S21_Q1_2026: "S21 T4 2025",
      EDF_OA_S21_Q4_2025: "S21 T3 2025",
      EDF_OA_S21_Q3_2025: "S21 T2 2025",
      EDF_OA_S21_Q2_2025: "S21 T1 2025",
      EDF_OA_S21_Q1_2025: "S21 T4 2024",
      EDF_OA_S21_Q4_2024: "S21 T3 2024",
      EDF_OA_S21_Q3_2024: "S21 T2 2024",
      EDF_OA_S21_Q2_2024: "S21 T1 2024",
      EDF_OA_S21_Q1_2024: "S21 T4 2023",
      EDF_OA_S21_Q4_2023: "S21 T3 2023",
      EDF_OA_S21_Q3_2023: "S21 T2 2023",
      EDF_OA_S21_Q1_2023: "S21 T4 2022",

      EDF_OA_S24_CORSICA_Q3_2026: "S24 T2 2026 (Corsica)",
      EDF_OA_S24_CORSICA_Q2_2026: "S24 T1 2026 (Corsica)",
      EDF_OA_S24_CORSICA_Q1_2026: "S24 T4 2025 (Corsica)",
      EDF_OA_S24_CORSICA_Q4_2025: "S24 T3 2025 (Corsica)",
      EDF_OA_S24_CORSICA_Q3_2025: "S24 T2 2025 (Corsica)",
      EDF_OA_S24_CORSICA_Q2_2025: "S24 T1 2025 (Corsica)",
      EDF_OA_S24_CORSICA_Q1_2025: "S24 T4 2024 (Corsica)",
      EDF_OA_S24_CORSICA_Q4_2024: "S24 T3 2024 (Corsica)",

      EDF_OA_S24_GUADELOUPE_Q3_2026: "S24 T2 2026 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q2_2026: "S24 T1 2026 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q1_2026: "S24 T4 2025 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q4_2025: "S24 T3 2025 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q3_2025: "S24 T2 2025 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q2_2025: "S24 T1 2025 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q1_2025: "S24 T4 2024 (Guadeloupe)",
      EDF_OA_S24_GUADELOUPE_Q4_2024: "S24 T3 2024 (Guadeloupe)",

      EDF_OA_S24_MARTINIQUE_Q3_2026: "S24 T2 2026 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q2_2026: "S24 T1 2026 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q1_2026: "S24 T4 2025 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q4_2025: "S24 T3 2025 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q3_2025: "S24 T2 2025 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q2_2025: "S24 T1 2025 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q1_2025: "S24 T4 2024 (Martinique)",
      EDF_OA_S24_MARTINIQUE_Q4_2024: "S24 T3 2024 (Martinique)",

      EDF_OA_S24_MAYOTTE_Q3_2026: "S24 T2 2026 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q2_2026: "S24 T1 2026 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q1_2026: "S24 T4 2025 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q4_2025: "S24 T3 2025 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q3_2025: "S24 T2 2025 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q2_2025: "S24 T1 2025 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q1_2025: "S24 T4 2024 (Mayotte)",
      EDF_OA_S24_MAYOTTE_Q4_2024: "S24 T3 2024 (Mayotte)",

      EDF_OA_S24_REUNION_ISLAND_Q3_2026: "S24 T2 2026 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q2_2026: "S24 T1 2026 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q1_2026: "S24 T4 2025 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q4_2025: "S24 T3 2025 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q3_2025: "S24 T2 2025 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q2_2025: "S24 T1 2025 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q1_2025: "S24 T4 2024 (La Réunion)",
      EDF_OA_S24_REUNION_ISLAND_Q4_2024: "S24 T3 2024 (La Réunion)",

      EDF_OA_S24_GUYANE_Q1_2025: "S24 T4 2024 (Guyane)",
      EDF_OA_S24_GUYANE_Q4_2024: "S24 T3 2024 (Guyane)",

      KWATTS_SPOT_LINKED: "Kwatts",
    },
    "section-headers": {
      EDF_OA_S21_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S21_Q2_2026: "1er trimestre 2026",
      EDF_OA_S21_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S21_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S21_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S21_Q2_2025: "1er trimestre 2025",
      EDF_OA_S21_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S21_Q4_2024: "3ème trimestre 2024",
      EDF_OA_S21_Q3_2024: "2ème trimestre 2024",
      EDF_OA_S21_Q2_2024: "1er trimestre 2024",
      EDF_OA_S21_Q1_2024: "4ème trimestre 2023",
      EDF_OA_S21_Q4_2023: "3ème trimestre 2023",
      EDF_OA_S21_Q3_2023: "2ème trimestre 2023",
      EDF_OA_S21_Q1_2023: "4ème trimestre 2022",

      EDF_OA_S24_CORSICA_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S24_CORSICA_Q2_2026: "1er trimestre 2026",
      EDF_OA_S24_CORSICA_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S24_CORSICA_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S24_CORSICA_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S24_CORSICA_Q2_2025: "1er trimestre 2025",
      EDF_OA_S24_CORSICA_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_CORSICA_Q4_2024: "3ème trimestre 2024",

      EDF_OA_S24_GUADELOUPE_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S24_GUADELOUPE_Q2_2026: "1er trimestre 2026",
      EDF_OA_S24_GUADELOUPE_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S24_GUADELOUPE_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S24_GUADELOUPE_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S24_GUADELOUPE_Q2_2025: "1er trimestre 2025",
      EDF_OA_S24_GUADELOUPE_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_GUADELOUPE_Q4_2024: "3ème trimestre 2024",

      EDF_OA_S24_MARTINIQUE_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S24_MARTINIQUE_Q2_2026: "1er trimestre 2026",
      EDF_OA_S24_MARTINIQUE_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S24_MARTINIQUE_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S24_MARTINIQUE_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S24_MARTINIQUE_Q2_2025: "1er trimestre 2025",
      EDF_OA_S24_MARTINIQUE_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_MARTINIQUE_Q4_2024: "3ème trimestre 2024",

      EDF_OA_S24_MAYOTTE_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S24_MAYOTTE_Q2_2026: "1er trimestre 2026",
      EDF_OA_S24_MAYOTTE_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S24_MAYOTTE_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S24_MAYOTTE_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S24_MAYOTTE_Q2_2025: "1er trimestre 2025",
      EDF_OA_S24_MAYOTTE_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_MAYOTTE_Q4_2024: "3ème trimestre 2024",

      EDF_OA_S24_REUNION_ISLAND_Q3_2026: "2ème trimestre 2026",
      EDF_OA_S24_REUNION_ISLAND_Q2_2026: "1er trimestre 2026",
      EDF_OA_S24_REUNION_ISLAND_Q1_2026: "4ème trimestre 2025",
      EDF_OA_S24_REUNION_ISLAND_Q4_2025: "3ème trimestre 2025",
      EDF_OA_S24_REUNION_ISLAND_Q3_2025: "2ème trimestre 2025",
      EDF_OA_S24_REUNION_ISLAND_Q2_2025: "1er trimestre 2025",
      EDF_OA_S24_REUNION_ISLAND_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_REUNION_ISLAND_Q4_2024: "3ème trimestre 2024",

      EDF_OA_S24_GUYANE_Q1_2025: "4ème trimestre 2024",
      EDF_OA_S24_GUYANE_Q4_2024: "3ème trimestre 2024",
    }
  },
  button: {
    "learn-more": "En savoir plus",
    "how-to-sell-vb": "Comment vendre du VB",
    "how-to-manage-vb": "Comment gérer Vb",
    "benefit-from-other": "Je veux bénéficier de l’offre",
    "photovoltaic-professional": "Je suis un professionnel photovoltaïque",
    "virtual-battery": "Batterie virtuelle",
    "purchase-contract": "Contrat d’achats",
    "select-offer-for-solar-project":
      "Sélectionner cette offre pour ce projet solaire",
  },
  "my-light": {
    statuses: {
      SIGNED: "Contrat signé",
      VERIFIED: "Contrat vérifié",
      NOT_ADDED: "Contrat indisponible",
      ACTIVATED: "Contrat soutirage activé",
      UNDRAFTED: "Contrat non signé",
      VALIDATED: "Contrat validé",
      CANCELLED: "Contrat annulé",
      VOIDED: "Contrat annulé",
    },
    types: {
      MY_BATTERY: "MyBattery",
      MY_SMART_BATTERY: "MySmartBattery",
    },
    hero: {
      "smart-battery": {
        title: "MySmartBattery",
        heading: "Batterie virtuelle MySmartBattery avec coffret",
        description:
          "Avec la batterie virtuelle MySmartBattery, stockez votre propre énergie et utilisez votre électricité en toute liberté à partir de 15€/mois.",
      },
      "my-battery": {
        title: "MyBattery",
        heading: "Batterie virtuelle MyBattery sans coffret",
        description:
          "MyBattery, la solution de batterie virtuelle pour stocker votre énergie solaire en illimité, sans matériel nécessaire.",
      },
    },
    "service-client": {
      title: "mylight150",
    },
    "feature-advantages": {
      title: "Pourquoi choisir mylight150 ?",
      "smart-battery": {
        description: "Offre de batterie virtuelle MySmartBattery",
        metropolis: "Métropole(Enedis)",
        mandatory: "Obligatoire",
        without: "Sans",
        "max-bill-saving": "Économies sur facture maximisées",
        "earn-more": "Gagner plus à chaque hausse des prix",
        subscription: "Abonnement à partir de 15 € par mois",
        storage: "Stockage par tranche",
      },
      "my-battery": {
        description: "Offre de batterie virtuelle MyBattery",
        metropolis: "Métropole(Enedis)",
        mandatory: "Obligatoire",
        without: "Sans",
        "max-bill-saving": "Économies sur facture maximisées",
        "earn-more": "Gagner plus à chaque hausse des prix",
        subscription: "Abonnement à 1 € par kWc par mois",
        storage: "Stockage illimité",
      },
    },
  },
  "urban-solar": {
    statuses: {
      SIGNED: "Contrat signé",
      VERIFIED: "Contrat vérifié",
      NOT_ADDED: "Contrat indisponible",
      ACTIVATED: "Contrat soutirage activé",
      UNDRAFTED: "Contrat non signé",
      VALIDATED: "Contrat validé",
      CANCELLED: "Contrat annulé",
      VOIDED: "Contrat annulé",
    },
    hero: {
      title: "Urban Solar Energy",
      "heading-professional": "Le Stockage Virtuel pour professionnels",
      "heading-individual": "Le Stockage Virtuel pour particuliers",
      "heading-less-production":
        "Vente de production Boost My Surplus (<36 kVA)",
      "heading-plus-production":
        "Vente de production Boost My Surplus (+36 kVA)",
      "description-professional":
        "Stockez et déstockez votre électricité non autoconsommée en illimité, sans équipement supplémentaire et en toute liberté.",
      "description-individual":
        "Stockez et déstockez votre électricité non autoconsommée en illimité, sans équipement supplémentaire et en toute liberté.",
      "description-less-production":
        "Autoconsommez et vendez votre surplus de production sans batterie virtuelle, sans équipement supplémentaire et sans engagement.",
      "description-plus-production":
        "Autoconsommez et vendez votre surplus de production sans batterie virtuelle, sans équipement supplémentaire et sans engagement.",
    },
    "customer-support": {
      title: "Urban Solar Energy",
      availability: "du lundi au vendredi de 08h à 20h - appel non surtaxé",
    },
    "feature-advantages": {
      title: "Pourquoi choisir Urban Solar Energy ?",
      description: "Offre de batterie virtuelle Le Stockage virtuel",
      metropolis: "Métropole",
      mandatory: "Obligatoire",
      "not-mandatory": "Pas Obligatoire",
      without: "Sans",
      "max-bill-saving": "Économies sur facture maximisées",
      "earn-more": "Gagner plus à chaque hausse des prix",
      subscription: "Abonnement à 1 € par kWc par mois",
      storage: "Stockage illimité",
      "same-energy": "Garder même fournisseur d’énergie",
      "simple-bank-transfer": "Virement bancaire simple une fois par an",
      commitment: "Sans engagement",
    },
    "price": {
        "market-spot-price": "Prix Spot du marché",
        description:
          "Urban Solar propose un prix Spot du kWh, calculé tous les mois et évoluant en fonction des fluctuations du marché, pour cette offre de contrat d’achat.",
      },
  },
  "ohm-energie": {
    statuses: {
      SIGNED: "Contrat signé",
      VERIFIED: "Contrat vérifié",
      NOT_ADDED: "Contrat indisponible",
      ACTIVATED: "Contrat soutirage activé",
      UNDRAFTED: "Contrat non signé",
      VALIDATED: "Contrat validé",
      CANCELLED: "Contrat annulé",
      VOIDED: "Contrat annulé",
    },
    types: {
      VIRTUAL_BATTERY: "Batterie virtuelle Ohm",
    },
    hero: {
      title: "Ohm Énergie",
      heading: "Batterie virtuelle Ohm",
      description:
        "Nouvelle batterie virtuelle du fournisseur et producteur d’énergie Ohm Énergie pour les particuliers et petites entreprises.",
    },
    "service-client": {
      title: "Ohm Énergie",
      availability: "du lundi au vendredi de 09h à 17h - appel non surtaxé",
    },
    "feature-advantages": {
      title: "Pourquoi choisir Ohm Énergie ?",
      description: "Offre de batterie virtuelle Ohm Énergie",
      metropolis: "Métropole (Enedis)",
      mandatory: "Obligatoire",
      without: "Sans",
      "max-bill-saving": "Économies sur facture maximisées",
      "earn-more": "Gagner plus à chaque hausse des prix",
      "customer-service": "Service client 7J/7 du fournisseur d’énergie",
      storage: "Stockage illimité",
    },
   
  },
  "octopus-energy": {
    hero: {
        title: "Octopus Energy",
        heading: "Contrat d’achat destiné aux particuliers",
        description:
          "Octopus Energy rachète le surplus qui n’est pas consommé dans son offre de pilotage destinée aux clients Octopus.",
      },
       "service-client": {
        title: "Octopus Energy",
        availability: "du lundi au vendredi de 09h à 17h",
      },
      price: {
          description:
            "Octopus Energy propose un prix unique pour cette offre de contrat d’achat.",
        },
        "feature-advantages": {
          title:
            "Pourquoi choisir Octopus Energy pour vendre son énergie solaire ?",
          description: "Offre d’achat de production solaire chez Octopus Energy",
          metropolis: "Métropole",
          mandatory: "Obligatoire",
          without: "Sans",
          "simple-purchase-price": "Un seul tarif d’achat simple",
          "monthly-payment": "Paiements mensuels par virement",
          "octopus-customer": "Offre pilote réservée aux clients Octopus",
          "without-subscription": "Sans abonnement",
        },
      
    },
  "total-energies": {

     hero: {
      title: "Énergies totales",
      heading: "Vente d'électricité au tarif d’achat OA",
      description: "Contrat d'achat hors obligation achat.",
     },
    "service-client": {
     
        title: "Énergies totales",
        availability: "Du lundi au samedi de 9h à 19h",
      },
      "feature-advantages": {
        title:
          "Pourquoi choisir Total Energies pour vendre son énergie solaire ?",
        description: "Offre d’achat de production solaire chez Total Energies",
        metropolis: "Métropole",
        mandatory: "Obligatoire",
        without: "Sans",
        "state-purchase": "Dispositif de l’État Obligation Achat",
        eld: "Régie locale de distribution ELD",
        "sale-of-surplus": "Vente de surplus ou en totalité",
        "same-energy": "Garder même fournisseur d’énergie",
      },
    },

  sunology: {
    hero: {
      title: "Sunology",
      heading: "Surplus +",
      description:
        "Offre de rachat du surplus de votre installation solaire à un prix fixe avec Sunology.",
    },
    "feature-advantages": {
      title: "Pourquoi choisir Sunology pour vendre son énergie solaire ?",
      description: "Offre d’achat de production solaire chez Sunology",
      metropolis: "Métropole",
      mandatory: "Obligatoire",
      without: "Sans",
      "all-type-of-solar": "Tous types d'installations solaires",
      "fixed-price": "Prix fixé",
      "payment-due": "Paiement tous les 6 mois",
      commitment: "Sans engagement",
    },
    price: {
      description: "Sunology propose un prix fixe par kWh.",
    },
    "service-client": {
      title: "Sunology",
      availability: "du lundi au vendredi de 9 h à 12h30 et de 14h à 17h30.",
    },
  },
  ekwateur: {
    hero: {
      "with-contract-heading": "Vente de production avec contrat Ekwateur",
      "without-contract-heading": "Vente de production sans contrat Ekwateur",
      title: "Ekwateur",
      description: "Offre de rachat du surplus avec les avantages Ekwateur.",
    },
    "service-client": {
      title: "Ekwateur Énergie",
      availability: "du lundi au vendredi de 9 h à 12 h et de 14h à 17h",
    },
    "feature-advantages": {
      title: "Pourquoi choisir Ekwateur pour vendre son énergie solaire ?",
      description: "Offre d’achat de production solaire chez Ekwateur",
      metropolis: "Métropole",
      mandatory: "Obligatoire",
      "not-mandatory": "Pas Obligatoire",
      without: "Sans",
      "all-type-of-solar": "Tous types d'installations solaires",
      "fixed-price": "Prix fixé pendant un an",
      "payment-due": "Paiement de votre dû tous les 6 mois",
      commitment: "Sans engagement",
    },
    price: {
      description:
        "Ekwateur propose un prix qui n’est pas fixe et qui évolue dans le temps pour cette offre de contrat d’achat.",
    },
  },
  kwatts: {
    hero: {
      title: "Kwatts",
      heading: "Contrat d’achat au prix de marché",
      description:
        "Offre de rachat au prix du marché sans frais d’entrée, sans abonnement et sans engagement.",
    },
    types: {
      SPOT_LINKED: "Achat de production",
    },
    "service-client": {
      title: "Kwatts",
    },
    price: {
      description:
        "kWatts propose un prix qui n’est pas fixe et qui évolue dans le temps pour cette offre de contrat d’achat.",
      "custom-price-text": "Prix de règlement des écarts de la RTE",
    },
    "feature-advantages": {
      title: "Pourquoi choisir Kwatts ?",
      description: "Offre d’achat de production solaire chez Kwatts",
      metropolis: "Métropole",
      without: "Sans",
      "same-energy": "Garder même fournisseur d’énergie",
      "sub-commitment": "Sans abonnement. Sans engagement.",
      "tracking-app": "Application de suivi en temps réel",
      "no-fee": "Sans frais d’entrée",
    },
  },
  "3erl": {
    hero: {
      title: "3ERL",
      heading: "Contrat d’achat à 70% du prix de marché",
      description:
        "L’association 3E-RL responsable d’équilibre sur le marché de l’électricité rachète la production d’électricité solaire au prix de règlement des écarts RTE du marché.",
    },
    "feature-advantages": {
      title: "Pourquoi choisir l’association 3E-RL ?",
      description: "Offre d’achat de production solaire chez 3E-RL",
      metropolis: "Métropole",
      without: "Sans",
      "same-energy": "Garder même fournisseur d’énergie",
      "sub-commitment": "Sans abonnement. Sans engagement.",
      "sale-of-surplus": "Vente de surplus ou en totalité",
      "no-fee": "Sans frais d’entrée",
    },
    price: {
      description:
        "3E-RL propose un prix qui n’est pas fixe et qui évolue dans le temps pour cette offre de contrat d’achat.",
      "custom-price-text": "70% du prix de règlement des écarts de la RTE",
    },
  },
  jpme: {
    hero: {
      title: "JPME",
      "fixed-individual": {
        heading: "E-Surplus Fixe Particuliers",
        description:
          "Vendez 100% de votre surplus de production solaire à un tarif d’achat fixe sans changer de fournisseur, avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "flex-individual": {
        heading: "E-Surplus Flex Particuliers",
        description:
          "Vendez 100% de votre surplus de production solaire au prix du marché et sans changer de fournisseur, avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "fixed-professionals": {
        heading: "E-Surplus Fixe Professionnels",
        description:
          "Vendez 100% de votre surplus de production solaire à un tarif d’achat fixe sans changer de fournisseur, avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "flex-professionals": {
        heading: "E-Surplus Flex Professionnels",
        description:
          "Vendez 100% de votre surplus de production solaire au prix du marché et sans changer de fournisseur, avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "e-battery-individual": {
        heading: "E-batterie pour particuliers (jusqu’à 15 kVA)",
        description:
          "Optimisez votre production d’électricité solaire avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "three-phase-e-battery-individual": {
        heading: "E-batterie pour particuliers en triphasé",
        description:
          "Optimisez votre production d’électricité solaire avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "low-voltage-professionals": {
        heading: "E-batterie pour professionnels en basse tension",
        description:
          "Optimisez votre production d’électricité solaire avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
      "high-voltage-professionals": {
        heading: "E-batterie pour professionnels en haute tension",
        description:
          "Optimisez votre production d’électricité solaire avec le fournisseur historique de batterie virtuelle Je Produis Mon Énergie (JPME).",
      },
    },
    "service-client": {
      title: "E-Surplus",
    },
    "feature-advantages": {
      title: "Pourquoi choisir JPME ?",
      metropolis: "Métropole",
      mandatory: "Obligatoire",
      without: "Sans",
      "same-energy": "Garder même fournisseur d’énergie",
      "simple-purchase-price": "Un seul tarif d’achat simple",
      "simple-bank-transfer": "Virement bancaire simple une fois par an",
      "without-subscription": "Sans abonnement",
      "all-type-of-solar": "Tous types d'installations solaires",
      "fixed-individual-desc":
        "Offre de batterie virtuelle E-Surplus Fixe pour particuliers",
      "flex-individual-desc":
        "Offre de batterie virtuelle E-Surplus Flex pour particuliers",
      "fixed-professional-desc":
        "Offre de batterie virtuelle E-Surplus Fixe pour professionnels",
      "flex-professional-desc":
        "Offre de batterie virtuelle E-Surplus Flex pour professionnels",
      "max-bill-saving": "Économies sur facture maximisées",
      "earn-more": "Gagner plus à chaque hausse des prix",
      commitment: "Sans engagement",
      storage: "Stockage illimité",
      "e-battery-desc":
        "Offre de batterie virtuelle E-Batterie pour particuliers chez JPME",
    },
    price: {
      description:
        "JPME propose un prix du kWh qui n’est pas fixe, évoluant toutes les heures en fonction des fluctuations du marché, pour cette offre de contrat d’achat.",
      "fixed-description":
        "JPME propose un prix unique fixe du kWh pour cette offre de contrat d’achat.",
      "price-observed": "Prix Spot EPEX constatées",
    },
  },
  "my-kit-solar": {
    hero: {
      title: "MonKitSolaire",
      "with-validate": {
        heading: "MK-surplus (avec Consuel validée)",
        description:
          "Une installation photovoltaïque avec une attestation de conformité Consuel validée ? Revendez votre surplus de production avec une tarification transparente à l’acteur historique du solaire MonKitSolaire.",
      },
      "without-validate": {
        heading: "MK-surplus (sans Consuel validée)",
        description:
          "Sans installation photovoltaïque ni attestation de conformité Consuel validée ? Revendez votre surplus de production avec une tarification transparente à l’acteur historique du solaire MonKitSolaire.",
      },
    },
    "service-client": {
      title: "MonKitSolaire",
      availability: "du lundi au samedi de 9 h à 12 h et de 14h à 17h",
    },
    "feature-advantages": {
      title: "Pourquoi choisir MonKitSolaire ?",
      enedis: "Enedis",
      "same-energy": "Garder même fournisseur d’énergie",
      "simple-purchase-price": "Un seul tarif d’achat simple",
      "simple-bank-transfer": "Virement bancaire simple une fois par an",
      "without-subscription": "Sans abonnement",
      description:
        "Offre de rachat du surplus avec une tarification transparente à l’acteur historique du solaire MonKitSolaire.",
    },
    price: {
      description:
        "MonKitSolaire propose un prix unique fixe du kWh pour cette offre de contrat d’achat.",
    },
  },
  "get-offer": {
    title: "Comment obtenir l’offre ?",
    description:
      "La valorisation de la production d’électricité est obtenue à la mise en service auprès du gestionnaire du réseau électrique.",
    subscribe: "Souscrire",
    "subscribe-desc":
      "Signer le contrat avec le fournisseur via signature électronique pour commander la mise en service.",
    commissioning: "Mise en service",
    "commissioning-desc":
      "Le gestionnaire du réseau électrique réceptionne la demande et met en service l’injection du surplus.",
    "activated-contract": "Contrat activé",
    "activated-contract-desc":
      "L’activation du contrat de l’offre est automatique. Votre surplus de production solaire est valorisée !",
  },

  features: {
    title: "Caractéristiques",
    advantages: "Avantages",
    "electrical-network": "Réseau électrique :",
    power: "Puissance :",
    "customer-consumption": "Consommation client :",
    "rge-installer": "Installateur RGE :",
  },

  "compare-other-offers": "Comparez d'autres offres",
  "consumption-price": "Prix consommation",
  price: "Prix",
  "storage-price": "Prix Stockage",
  "purchase-per-kwh": "Tarif d’achat du kWh",
  "price-per-kwh": "Prix du kWh",
  "price-per-kwh-option-base": "Prix du kWh <br/> Option Base",
  "last-updated": "Dernière mise à jour",
  "email-address": "Adresse email",
  phone: "Téléphone",
  "service-care-availability":
    "du lundi au vendredi de 09h à 17h - appel non surtaxé",
  "customer-service": "Service Client",
  contact: "Contact",
  "contact-owner": "Contact propriétaire",
  "contact-professional": "Contact professionnel",
  power: "Puissance",
  "sub-per-month": "Abonnement (€/mois)",
  consumption: "Consommation",
  "consumption-period": "Période de consommation",
  "subs-fee": "Frais de souscription",
  "in-one-go": "En une seule fois",
  "monthly-subscription": "Abonnement Mensuel",
  "depend-on-size": "(Dépendant de la taille de l'installation)",
  "depend-on-size-photovoltaic":
    "Selon la taille de l’installation photovoltaïque",
  "routing-rate": "Tarif Acheminement",
  "shipping-fee": "Taxe d’acheminement ",
  "peak-hours": "Heure Pleines",
  "off-peak-hours": "Heure Creuses",
  "subscribed-power": "Puissance<br/> Souscrite",
  "peak-hours-price": "Prix du KWh<br/> Heures pleines",
  "off-peak-hours-price": "Prix du KWh<br/> Heures creuses",
  "monthly-sub": "Abonnement<br/> Mensuel",
  "battry-capacity": "Capacité<br/> Batterie",
  "monthly-package": "Forfait<br/> mensuel",
  "purchase-contract-fees": "Frais du contrat d’achat",
  "start-up-cost": "Frais de démarrage",
  "price-in-consumption": "Prix fourniture énergie en consommation",
  "virtual-battery-charges": "Frais de la batterie virtuelle",
  "coef-capacity": "Coef capa",
  "share-energy": "Part énergie",
  forwarding: "Acheminement",
  sub: "Abonnement",
  "price-energy": "Prix énergie",
  "fixed-part": "Part fixe",
  "variable-part": "Part variable",
  taxes: "Taxes",
  "according-to-power": "(Selon la puissance photovoltaïque)",
}
